module.exports = __webpack_public_path__ + "static/media-emulation-6e1bf1bb2d8f0596d90ffebee3aa6f6e.png";